import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Customers_Object} state
 *  @property {object} model
 *  @property {Customers_Properties} model.properties
 *  @property {Customers_Is} model.is
 *  @property {Customers_Has} model.has
 */
export default class CustomerBlacklist extends ObjectOverride {
	constructor(props) {
		super(props, Types.Customers._name);
	}

	/**
	 * @param prevProps
	 * @param {Customers_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Customers_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.name_first + " " + object.name_last);
		}
	}

	handleProcess(event, requestOverride) {
		let result = true;

		if (!this.state.blacklist_reason) {
			this.setState({
				blacklist_reason_error: 'Blacklist reason is required',
			})
			result = false;
		}
		//If either is false then fail
		return result && super.handleProcess(event, requestOverride);
	}


	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		if (typeof this.props.setNewObject === 'function') {
			this.props.setNewObject(data);
		}
	};

	form = () => {
		/** @type {Customers_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>

					<div className="form-group">
						<Framework.Elements.TextField
							label={"Reason"}
							value={object.blacklist_reason}
							error={object.blacklist_reason_error}
							property={properties.blacklist_reason}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>

				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
